import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import 'rc-color-picker/assets/index.css';
import {TopButtonCancel, TopButtonSave} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import {TopAlertInformacja} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import NumberUilities from "../../../../../../utilities/NumberUilities";
import Validator from "../../../../../../utilities/Validator";
var tinycolor = require("tinycolor2");

export default class PolaczenieEkipyIPojazdowForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ekipa: null,
            pojazd: null,
            zmiana:'',
            polaczenia_juz_dodane:[],
            validateMessages:[],
        };
        this.onChangeEkipa = this.onChangeEkipa.bind(this)
        this.onChangePojazd = this.onChangePojazd.bind(this)
        this.onChangeZmiana = this.onChangeZmiana.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.renderOptionEkipa = this.renderOptionEkipa.bind(this)
        this.renderPolaczeniaJuzDodane = this.renderPolaczeniaJuzDodane.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.polaczenie)) {
            this.setState({
                pojazd: this.props.pojazdy.find(k => k.idPo === this.props.polaczenie.idPo),
                ekipa: this.props.ekipy.find(e => e.idEk === this.props.polaczenie.idEk),
                polaczenia_juz_dodane:this.props.polaczenia.filter(p=>p.idEk === this.props.polaczenie.idEk),
                zmiana: (Boolean(this.props.polaczenie.zmiana))? this.props.polaczenie.zmiana : ''
            })

            if(Boolean(this.props.polaczenie.zmiana))
                document.getElementById('zmianaInput').value = this.props.polaczenie.zmiana
        }
    }

    componentWillReceiveProps(nextprops){
        if(nextprops.polaczenie){
            this.setState({
                pojazd: this.props.pojazdy.find(k => k.idPo === nextprops.polaczenie.idPo),
                ekipa: this.props.ekipy.find(e => e.idEk === nextprops.polaczenie.idEk),
                polaczenia_juz_dodane:this.props.polaczenia.filter(p=>p.idEk === nextprops.polaczenie.idEk),
                zmiana: (Boolean(nextprops.polaczenie.zmiana))? nextprops.polaczenie.zmiana : ''
            })
            if(Boolean(nextprops.polaczenie.zmiana))
                document.getElementById('zmianaInput').value = nextprops.polaczenie.zmiana
        }
    }

    onChangeEkipa(e) {
        this.setState({ekipa: e})
        if(e!==null){
            this.setState({
                polaczenia_juz_dodane:this.props.polaczenia.filter(p=>p.idEk === e.idEk)
            })
        }
        else{
            this.setState({polaczenia_juz_dodane:[]})
        }
    }

    onChangePojazd(e) {
        this.setState({pojazd: e})
    }

    onChangeZmiana(e){
        this.setState({zmiana:e.target.value})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true; this.state.validateMessages = [];

        if(!Boolean(this.state.ekipa)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano ekipy')
        }

        if(!Boolean(this.state.pojazd)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano pojazdu')
        }

        if(!Boolean(this.state.zmiana)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wprowadzono numeru zmiany')
        }

        if(!Validator.validateInt(this.state.zmiana)){
            poprawne = false;
            this.dodajDoValidatorMessages('Zmiana musi być liczbą całkowitą nieujemną')
        }

        if (poprawne) {

            this.setState({validateMessages:[]})

            let date = {
                "idEkSt": this.state.ekipa.idEkSt,
                "idEk": this.state.ekipa.idEk,
                "idPo": this.state.pojazd.idPo,
                "idPoSt": this.state.pojazd.idPoSt,
                "zmiana":NumberUilities.parseStringToNumber(this.state.zmiana)
            }

            if (Boolean(this.props.polaczenie)) {
                this.props.handleClickZapisz(date, true)
            }
            else {
                this.props.handleClickZapisz(date, false)
            }
        }
    }

    renderOptionEkipa(option) {
        let color = 'grey';

        if((tinycolor(option.kolor)).isDark()){
            color = '#ffffff'
        }
        if((tinycolor(option.kolor)).isLight()){
            color = '#000000'
        }

        return (
            <div>
                        <span className={'label label-ebus-default'}
                              style={(option.kolor.length > 1) ? {background: option.kolor, color:color} : {background: '#f5f5f5', color: '#333333'}}>
                            {option.kodEk}
                        </span>
                <span style={{marginLeft: '10px'}}>{option.nazwaEk}</span>
            </div>
        )
    }

    renderPolaczeniaJuzDodane(){
        let prev = null;
        let arr = []
        this.state.polaczenia_juz_dodane.map(item=>{
            if(prev !== item.zmiana && item.zmiana !==null){
                prev = item.zmiana
                arr.push(item.zmiana)
            }
        })
        arr.push(null);

        return(
            <div style={{marginTop:'15px'}}>
                <TopAlertInformacja text={'Pojazdy już dodane do wybranej trasy:'}/>
            <ul>
                {arr.map(zmiana=>{
                    return <div>
                        <h5 style={{color:'gray',fontStyle:'italic', margin:'10px 0 0 0'}}>{Boolean(zmiana)? 'Zmiana '+zmiana+':' : 'Pozostali:'}</h5>
                        {
                            this.state.polaczenia_juz_dodane.filter(pz=> pz.zmiana == zmiana).map(p=>{
                                let pojazd = this.props.pojazdy.find(k=>k.idPo === p.idPo)
                                if(Boolean(pojazd)){
                                    return <li key={p.idEkp}>{pojazd.informacje}</li>
                                }
                            })

                        }
                    </div>
                })}

            </ul>
            </div>
        )
    }

    renderPojazdSelect(option){
        return(
            <div>
                <span>{option.informacje}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status)?
                            <span style={{fontSize:'12px',color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                            :
                            <span style={{fontSize:'12px',color:'firebrick'}}><i className={'fa fa-times'}></i> niedostępny</span>

                    }
                </div>
            </div>
        )
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.polaczenie) ? 'Edycja połączenia' : 'Nowe połączenie'}</div>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col xs={12} sm={6} md={3} lg={3}>
                            <ControlLabel>
                                Ekipa <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeEkipa} value={this.state.ekipa} options={this.props.ekipy} valueKey={'idEk'}
                                       labelKey={'kodEk'} placeholder={'Szukaj po kodzie'} valueRenderer={this.renderOptionEkipa} optionRenderer={this.renderOptionEkipa}/>
                        </Col>
                        <Col xs={12} sm={6} md={3} lg={3}>
                            <ControlLabel>
                                Pojazd <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangePojazd} value={this.state.pojazd} options={this.props.pojazdy} valueKey={'idPo'}
                                       labelKey={'informacje'} placeholder={'Szukaj po: marka, model, rejestracja'}
                                        valueRenderer={this.renderPojazdSelect} optionRenderer={this.renderPojazdSelect}
                            />
                        </Col>
                        <Col xs={12} sm={6} md={3} lg={1}>
                            <ControlLabel>
                                Zmiana <span className={'req'}>*</span>
                            </ControlLabel>
                            <FormControl type={'number'} onChange={this.onChangeZmiana} id={'zmianaInput'}/>
                        </Col>
                        <Col xs={12} sm={6} md={3} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonCancel onClick={() => {
                                this.props.handleClickAnuluj()
                            }} text={'Anuluj'}/>
                            <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.polaczenia_juz_dodane.length>0}>
                                <div>{this.renderPolaczeniaJuzDodane()}</div>
                            </TopIf>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validateMessages}/>
                    </FormGroup>
                </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipIPojazdow/components/PolaczenieEkipyIPojazdowForm.js